<template>

    <div class="vld-parent">

        <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

        <!-- BEGIN SECTION CONTENT -->
        <div :id="sectionId" class="category-section-container py-5 px-4 bg-theme-level3 text-theme-main">

            <!--v-for="(contentPiece, index) in contentPayload" v-if="(contentPiece.render_size === 'Pequeño' || contentPiece.render_size === 'Small')"-->
            <content-module-small
                v-for="(contentPiece, index) in contentPayload"
                v-bind:key="contentPiece.id"
                :content="contentPiece"
                :currentlocale="currentlocale"
                :legacy="contentPiece.legacy"
                :default_thumbnail="default_thumbnail"
            ></content-module-small>
            <!-- END SECTION CONTENT -->

        </div>

        <div class="px-6 pb-6 flex flex-row items-center justify-start">

            <span class="flex flex-row items-center justify-start" v-if="this.lastPage > 1">

                <p class="text-sm text-theme-discrete mt-2 mb-2 mr-6 md:mr-0">{{ translate('page-current') }}{{ this.currentPage }}{{ translate('page-of') }}{{ this.lastPage }}</p>

                <i v-if="!smartphone"
                    :class="{
                        'hover:bg-theme-controls2': this.currentPage > 1,
                        'cursor-pointer': this.currentPage > 1,
                    }"
                    class="material-icons rounded-full text-theme-discrete ml-4 mr-2 pl-2 pt-2 w-10 h-10 ml-12"
                    @click="getPreviousPage">navigate_before</i>

                <span
                    :class="{
                        'hover:text-theme-title': this.currentPage > 1,
                        'cursor-pointer': this.currentPage > 1,
                    }"
                    class="text-sm text-theme-discrete mt-2 mb-2 rounded-lg"
                    @click="getPreviousPage">
                    {{translate('page-previous') }}
                </span>

                <span
                    :class="{
                        'hover:text-theme-title': this.currentPage < this.lastPage,
                        'cursor-pointer': this.currentPage < this.lastPage,
                    }"
                    class="ml-6 md:ml-12 text-sm text-theme-discrete mt-2 mb-2 rounded-lg"
                    @click="getNextPage">
                    {{translate('page-next') }}
                </span>

                <i v-if="!smartphone"
                    :class="{
                        'hover:bg-theme-controls2': this.currentPage < this.lastPage,
                        'cursor-pointer': this.currentPage < this.lastPage,
                    }"
                    class="material-icons rounded-full text-theme-discrete ml-4 mr-2 pl-2 pt-2 w-10 h-10"
                    @click="getNextPage">navigate_next</i>

            </span>

            <span v-else>
                <p class="text-sm text-theme-discrete mt-2 mb-2">{{ translate('page-no-more') }}</p>
            </span>

        </div>

    </div>

</template>

<script>

    import { isMobileOnly } from 'mobile-device-detect';
    import { isTablet } from 'mobile-device-detect';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            Loading
        },

        data() {
            return {
                componentLoading: true,
                contentPayload: '',
                currentPage: '',
                lastPage: '',

                smartphone: isMobileOnly,
                tabletDevice: isTablet,
            }
        },

        props: [
            'currentlocale',
            'category_id',
            'sub_category_id',
            'selectedcountries',
            'selectedcorrespondents',
            'selectedtags',
            'default_thumbnail',
            'index'
        ],

        computed: {

            sectionId() {
                return 'sectionTop' + this.index;
            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            getPreviousPage() {

                this.componentLoading = true;

                if(this.currentPage > 1) {

                    let finalURL = '/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id;

                    if(this.selectedcountries && this.selectedcountries !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedcountries).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {

                        finalURL += '/none';

                    }

                    if(this.selectedcorrespondents && this.selectedcorrespondents !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedcorrespondents).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {
                        finalURL += '/none';
                    }

                    if(this.selectedtags && this.selectedtags !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedtags).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {
                        finalURL += '/none';
                    }

                    /*axios.get('/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id + '/' + (this.currentPage - 1))*/
                    axios.get(finalURL + '/' + (this.currentPage - 1))
                        .then(response => {
                            this.componentLoading = false;
                            this.contentPayload = response.data.data;
                            this.currentPage = response.data.current_page;
                        })
                        .catch(error => {
                            console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                        });
                }

            },

            getNextPage() {

                this.componentLoading = false;

                if(this.currentPage < this.lastPage ) {

                    let finalURL = '/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id;

                    if(this.selectedcountries && this.selectedcountries !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedcountries).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {

                        finalURL += '/none';

                    }

                    if(this.selectedcorrespondents && this.selectedcorrespondents !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedcorrespondents).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {
                        finalURL += '/none';
                    }

                    if(this.selectedtags && this.selectedtags !== 'none') {

                        let tmpArray = [];

                        JSON.parse(this.selectedtags).forEach(data => {
                            tmpArray.push(data.id)
                        })

                        finalURL += '/' + tmpArray.join();

                    } else {
                        finalURL += '/none';
                    }


                    /*axios.get('/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id + '/' + (this.currentPage + 1))*/
                    axios.get(finalURL + '/' + (this.currentPage + 1))
                        .then(response => {
                            this.componentLoading = false;
                            this.contentPayload = response.data.data;
                            this.currentPage = response.data.current_page;
                        })
                        .catch(error => {
                            console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                        });

                }

                this.scrollToEnd();

            },

            scrollToEnd: function() {
                if(this.smartphone) {
                    let element = document.getElementById("sectionTop" + this.index);
                    element.scrollIntoView({behavior: "smooth"});
                }
            },

        },

        mounted() {

        },

        created() {

            var finalURL = '/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id;

            if(this.selectedcountries && this.selectedcountries !== 'none') {

                let tmpArray = [];

                JSON.parse(this.selectedcountries).forEach(data => {
                    tmpArray.push(data.id)
                })

                finalURL += '/' + tmpArray.join();

            } else {

                finalURL += '/none';

            }

            if(this.selectedcorrespondents && this.selectedcorrespondents !== 'none') {

                let tmpArray = [];

                JSON.parse(this.selectedcorrespondents).forEach(data => {
                    tmpArray.push(data.id)
                })

                finalURL += '/' + tmpArray.join();

            } else {
                finalURL += '/none';
            }

            if(this.selectedtags && this.selectedtags !== 'none') {

                let tmpArray = [];

                JSON.parse(this.selectedtags).forEach(data => {
                    tmpArray.push(data.id)
                })

                finalURL += '/' + tmpArray.join();

            } else {
                finalURL += '/none';
            }

            console.log(finalURL);

            /*axios.get('/api/content/' + this.currentlocale + '/' + this.category_id + '/' + this.sub_category_id)*/
            axios.get(finalURL)
                .then(response => {
                    this.componentLoading = false;
                    this.contentPayload = response.data.data;
                    this.currentPage = response.data.current_page;
                    this.lastPage = response.data.last_page;
                })
                .catch(error => {
                    console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                });

        },

    }

</script>


<style scoped>

    :root {
        --spacing: 100px;
    }

    .category-section-container {

        display: grid;
        grid-gap: 35px;
        grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
        grid-template-rows: 280px;
        grid-auto-rows: 280px;
    }

    /*.section-container {
        overflow-y: scroll;
    }*/

    .hs > li,
    .item {
        scroll-snap-align: center;
        padding: calc(var(--gutter) / 2 * 1.5);
        /*margin-top: 10px;
        margin-bottom: 10px;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 8px;
    }

</style>
